import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '..';
import { CONTROLLERS, ENDPOINTS } from '../../constants';
import {
  Campaign,
  CampaignListReq,
  CampaignListResp,
  CampaignPaidPatientsListResponse,
  CampaignResp,
  Response,
} from '../../models';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private api: string = CONTROLLERS.TENANTS.CAMPAIGN;
  constructor(private apiService: ApiService) {}

  getCampaignList(
    arCampaignListReq: CampaignListReq
  ): Observable<Response<CampaignListResp>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.CAMPAIGN.GET_CAMPAIGN_LIST}`,
      arCampaignListReq
    );
  }

  getCampaignById(campaignId: number): Observable<Response<CampaignResp>> {
    return this.apiService.getById(
      campaignId.toString(),
      `${this.api}/${ENDPOINTS.TENANTS.CAMPAIGN.GET_CAMPAIGN_BY_ID}`
    );
  }

  createOrUpdateCampaign(campaign: Campaign) {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.CAMPAIGN.CREATE_OR_UPDATE_CAMPAIGN}`,
      campaign
    );
  }
  getCampaignPaidPatients(request: CampaignListReq): Observable<Response<CampaignPaidPatientsListResponse>> {
    return this.apiService.post(
      `${this.api}/${ENDPOINTS.TENANTS.CAMPAIGN.GET_CAMPAIGN_PAID_PATIENTS}`,
      request
    );
  }
}
